export default {
  outList: [
    {
      light_point_2:[
        {
          title: '动感鳍线尾翼 ',
          type: 'image',
          video: '',
          image: 'lightPoint/out/1.jpg',
          text: '此刻静止 为了更好的冲锋'
        }
      ],
      light_point_1:[
        {
          title: '潮感流线车身',
          type: 'image',
          video: '',
          image: 'lightPoint/out/3.jpg',
          text: '自带风度 人群里的焦点'
        }
      ],
      light_point_3:[
        {
          title: '超感红色卡钳',
          type: 'image',
          video: '',
          image: 'lightPoint/out/5.jpg',
          text: '一抹明媚 醒目一路风景'
        }
      ],
      light_point_4:[
        {
          title: 'T型日行灯 ',
          type: 'image',
          video: '',
          image: 'lightPoint/out/1.jpg',
          text: '持续放电 前路高能不断'
        }
      ],
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '寰宇星云沉浸环绕屏',
          type: 'image',
          video: '',
          image: 'lightPoint/in/9.png',
          text: '无缝设计双联屏带来极为震撼的视觉效果，让主驾驶者视线集中、便捷操作，感受沉浸式视觉体验'
        }
      ],
      light_point_2:[
        {
          title: ' 体温模拟加热方向盘',
          type: 'image',
          video: '',
          image: 'lightPoint/in/2_1.png',
          text: '5min内达到20度，15min达到体温37度，解决冬季冻手尴尬的同时设置多重保护，安心舒适。'
        }
      ],
      light_point_3:[
        {
          title: '幻境内饰 水晶映射档杆',
          type: 'image',
          video: '',
          image: 'lightPoint/in/1.png',
          text: '三档五位电子式换挡操纵机构。水晶材质档杆，品质感满满。'
        }
      ],
      light_point_4:[
        {
          title: '一体式人体工学运动座椅',
          type: 'image',
          video: '',
          image: 'lightPoint/in/4.png',
          text: '时尚撞色运动座椅,电动座椅+加热+通风'
        }
      ],
      light_point_5:[
        {
          title: 'SONY殿堂级音响',
          type: 'image',
          video: '',
          image: 'lightPoint/in/6.png',
          text: '全方位8扬声系统，“金耳朵”大师团队专属调音，打造独有沉浸式、高品质音乐体验。'
        }
      ]
    }
  ],
  tab1:[
    {
      title: '动感鳍线尾翼 ',
      type: 'image',
      video: '',
      image: 'lightPoint/out/1.jpg',
      text: '此刻静止 为了更好的冲锋'
    },
    {
      title: 'LED贯穿式尾灯',
      type: 'image',
      video: '',
      image: 'lightPoint/out/2.jpg',
      text: '风驰电掣 突破沉寂的夜'
    },
    {
      title: '超感红色卡钳',
      type: 'image',
      video: '',
      image: 'lightPoint/out/5.jpg',
      text: '一抹明媚 醒目一路风景'
    },
    {
      title: 'T型日行灯 ',
      type: 'image',
      video: '',
      image: 'lightPoint/out/1.jpg',
      text: '持续放电 前路高能不断'
    },
    {
      title: '潮感流线车身',
      type: 'image',
      video: '',
      image: 'lightPoint/out/3.jpg',
      text: '自带风度 人群里的焦点'
    }
  ],
  tab2: [
    {
      title: '幻境内饰 水晶映射档杆',
      type: 'image',
      video: '',
      image: 'lightPoint/in/1.png',
      text: '三档五位电子式换挡操纵机构。水晶材质档杆，品质感满满。'
    },
    {
      title: '三大主题内饰',
      type: 'image',
      video: '',
      image: 'lightPoint/in/2_1.png',
      text: '灰域：蓝灰+灰色内饰，光场：黑色内饰，影动：天蓝+黑+灰色内饰'
    },
  ],
  tab3: [
    {
      title: '超科技HMI5.0交互界面',
      type: 'image',
      video: '',
      image: 'lightPoint/in/3.png',
      text: 'AI情感超级交互系统,人脸识别及无感登陆,全时免唤醒多模语音交互,驾驶员状态识别交互,驾乘行为识别交互,真人语音交互系统'
    }
  ],
  tab4: [
    {
      title: '一体式人体工学运动座椅',
      type: 'image',
      video: '',
      image: 'lightPoint/in/4.png',
      text: '时尚撞色运动座椅,电动座椅+加热+通风'
    },
    {
      title: '体温模拟加热方向盘',
      type: 'image',
      video: '',
      image: 'lightPoint/in/5.png',
      text: '5min内达到20度，15min达到体温37度，解决冬季冻手尴尬的同时设置多重保护，安心舒适。'
    },
    {
      title: 'SONY殿堂级音响',
      type: 'image',
      video: '',
      image: 'lightPoint/in/6.png',
      text: '全方位8扬声系统，“金耳朵”大师团队专属调音，打造独有沉浸式、高品质音乐体验。'
    },
    {
      title: '64色律动氛围灯',
      type: 'image',
      video: '',
      image: 'lightPoint/in/7_2.png',
      text: '64色氛围灯，与驾驶模式联动，随着音乐律动，营造沉浸式奢适体验；'
    },
    {
      title: '中控无线充电及冷藏功能',
      type: 'image',
      video: '',
      image: 'lightPoint/in/8.png',
      text: '前排中控扶手箱可容纳4瓶500ml饮料，夏天冷藏冬天加热保温，让用户悦享驾驶与乘坐体验'
    }
  ],
  tab5: [
    {
      title: '寰宇星云沉浸环绕屏',
      type: 'image',
      video: '',
      image: 'lightPoint/in/9.png',
      text: '无缝设计双联屏带来极为震撼的视觉效果，让主驾驶者视线集中、便捷操作，感受沉浸式视觉体验'
    }
  ],
}
